const AppState = {
  instance: {
    showIframePopup: false,
    iframePopupUrl: null,
    iframePopupBoardList: false,
    routerViewHeight: null,
    routerViewWidth: null,
    showTerms: false,
    showVinnigar: false,
    showVuePopup: false,
    showProtection: false,
    showPlayerBoard: false,
    doShowtermsPopup () {
      this.showTerms = true
      this.showVinnigar = false
      this.showProtection = false
      this.showVuePopup = true
      this.showPlayerBoard = false
    },

    doShowvinnigarPopup () {
      this.showVinnigar = true
      this.showTerms = false
      this.showVuePopup = true
      this.showProtection = false
      this.showPlayerBoard = false
    },

    doShowProtectionPopup () {
      this.showProtection = true
      this.showVinnigar = false
      this.showVuePopup = true
      this.showTerms = false
      this.showPlayerBoard = false
    },

    doShowPlayerBoardPopup () {
      this.showProtection = false
      this.showVinnigar = false
      this.showVuePopup = true
      this.showTerms = false
      this.showPlayerBoard = true
    },

    doHidetermsPopup () {
      this.showTerms = false
      this.showVuePopup = false
    },
    doHidevinigarPopup () {
      this.showVinnigar = false
      this.showVuePopup = false
    },
    doHideprotectionPopup () {
      this.showProtection = false
      this.showVuePopup = false
    },
    doHidePlayerBoardPopup () {
      this.showPlayerBoard = false
      this.showVuePopup = false
    }
  }
}

const AppStateMixin = {
  data () {
    return { appState: AppState.instance }
  }
}

export default AppStateMixin
